import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  padding: 120px 24px;
  position: relative;
  overflow: hidden;
`;

export const BackgroundAccent = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(133, 76, 230, 0.08), rgba(0, 70, 209, 0.08));
  opacity: 0.7;
  z-index: 0;
  pointer-events: none;
`;

export const Wrapper = styled.div`
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
`;

export const ToggleButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  background: rgba(20, 22, 35, 0.6);
  border-radius: 999px;
  padding: 6px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  @media (max-width: 768px) {
    display: none;
  }
`;

export const ToggleButton = styled.button`
  border: none;
  padding: 10px 20px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  color: ${({ active, theme }) => (active ? theme.text_primary : theme.text_secondary)};
  background: ${({ active, theme }) =>
    active ? 'linear-gradient(120deg, rgba(133,76,230,0.9), rgba(0,70,209,0.9))' : 'transparent'};
  transition: background 0.2s ease, color 0.2s ease;
  @media (max-width: 768px) {
    min-width: 140px;
    flex-shrink: 0;
  }
`;

export const CardContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 28px;
`;

export const GradientFade = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 220px;
  background: ${({ theme }) => `
    linear-gradient(
      180deg,
      rgba(28, 28, 39, 0) 0%,
      ${theme.bgLight || theme.bg} 55%,
      rgba(8, 9, 17, 0.95) 100%
    )
  `};
  pointer-events: none;
  z-index: 0;
`;
